import useSWR, { SWRConfiguration } from 'swr'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { PAGINATION_ORDER } from 'shared/constants/api'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { CommentInterface } from 'modules/comments/components/comment/comment.types'
import { commentSourceKeyMap } from 'modules/comments/utils/constants'

export const getPinnedCommentsKey = ({
  lastCommentId,
  parentId,
  postId,
  sortOrder = PAGINATION_ORDER.ASC,
  targetCommentId,
}: {
  lastCommentId: number
  parentId: number | null
  postId: number
  sortOrder: (typeof PAGINATION_ORDER)[keyof typeof PAGINATION_ORDER]
  targetCommentId?: number
}): string => {
  const searchParams = new URLSearchParams()

  searchParams.set('pagination[order]', sortOrder)
  searchParams.set(commentSourceKeyMap.community, postId.toString())
  searchParams.set('parent', parentId?.toString() ?? 'null')
  if (targetCommentId) {
    searchParams.set('commentId', targetCommentId.toString())
  }
  if (lastCommentId !== 0) {
    searchParams.set('pagination[startFrom]', lastCommentId.toString())
  }

  return `${COMMENT_API_PREFIX}/pinned?${searchParams.toString()}`
}

interface UsePinnedCommentsOptions {
  lastCommentId: number
  parentId: number | null
  postId: number
  sortOrder: (typeof PAGINATION_ORDER)[keyof typeof PAGINATION_ORDER]
  targetCommentId?: number
  config?: SWRConfiguration<CommentInterface[], Error>
}

export const usePinnedComments = ({
  lastCommentId,
  parentId,
  postId,
  sortOrder,
  targetCommentId,
  config,
}: UsePinnedCommentsOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, CommentInterface[]>({
    method: RequestMethodsEnum.get,
  })

  return useSWR<CommentInterface[]>(
    getPinnedCommentsKey({
      lastCommentId,
      parentId,
      postId,
      sortOrder,
      targetCommentId,
    }),
    fetcher,
    config,
  )
}
